import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tree_select = _resolveComponent("a-tree-select")!

  return (_openBlock(), _createBlock(_component_a_tree_select, {
    value: _ctx.value,
    "allow-clear": "",
    "show-search": "",
    disabled: _ctx.disabled,
    multiple: false,
    placeholder: _ctx.placeholder,
    "tree-data": _ctx.afterRecords(_ctx.records),
    "tree-node-filter-prop": "title",
    onChange: _ctx.onChange,
    onClear: _ctx.onClear,
    class: _normalizeClass(_ctx.class),
    fieldNames: { label: 'name', value: 'id' }
  }, null, 8, ["value", "disabled", "placeholder", "tree-data", "onChange", "onClear", "class"]))
}